export default "__VITE_ASSET__37cebb35__"